export default __webpack_public_path__ + "static/media/sav10.be717f8c.jpg";